import { AlertService } from './../../services/alert.service';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Component, OnInit, Renderer, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard'
import { EmailnotificationService } from 'src/app/services/emailnotification.service';
import { EmailTemplate } from 'src/app/model/emailTemplate.modals';
import Swal from 'sweetalert2';
import { DataSource } from '@angular/cdk/collections/typings/data-source';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { TemplateTypesEnum } from '../../enum/email-templates.enum'
import {map} from 'rxjs/operators';
// declare var $:any;

@Component({
  selector: 'app-emailtemplate',
  templateUrl: './emailtemplate.component.html',
  styleUrls: ['./emailtemplate.component.css']
})
export class EmailtemplateComponent implements OnInit {
  emailTemplates: MatTableDataSource<any>;
  noData: any;
  applicationId: any = '5cca835523338a1014cd4b85';
  orgId:any;
  is_copied: boolean = false;
  angularCodeSample: string;
  type:number;
  displayedColumns: string[] = ['templateName','applicationName','templateCode','to','subject','status','actions'];
  isLoading:boolean;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('dropdown') dropdown: ElementRef
  constructor(private router: Router,
    private toastService:ToastrService,
    private emailnotificationService: EmailnotificationService,
    private _clipboardService: ClipboardService) { }

  ngOnInit() {
    this.orgId=localStorage.getItem('org_id')
    this.type=+localStorage.getItem('type')
    this.getOrgEmailTemplates()
  }
  copyToClipboard(action) {
    this.is_copied = this._clipboardService.copyFromContent(action);
    setTimeout(() => {
      this.is_copied = false
    }, 700);

  }
  addTemplate(type:string) {
    if(type==TemplateTypesEnum.APPLICATION)
      this.router.navigate(['addtemplate'], { queryParams: { opt: 'add',type:TemplateTypesEnum.APPLICATION} });
    else if(type==TemplateTypesEnum.ORGANIZATION)
      this.router.navigate(['addtemplate'], { queryParams: { opt: 'add',type:TemplateTypesEnum.ORGANIZATION} })
    else
      this.router.navigate(['addtemplate'], { queryParams: { opt: 'add',type:TemplateTypesEnum.TENET} })
  }
  applyFilter(event: Event) {
    this.noData = this.emailTemplates.connect().pipe(map(data => data.length === 0));
    let filterValue = (event.target as HTMLInputElement).value;
    this.emailTemplates.filter = filterValue.trim().toLowerCase();
  }
  closeAlert() {
    this.is_copied = false;
  }
  deleteTemplate(templateId:string){
    Swal({
      title: 'Are you sure you want delete?',
      text: "You won't be able to revert this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.emailnotificationService.deleteEmailTemplate(templateId).subscribe(
          (result:any)=>{
            if(!result.error){
              this.getOrgEmailTemplates();
              this.toastService.success('Template deleted successfully')
            }
          },
          (err)=>{
            this.toastService.error(err.message)
          }
        )
      }
    })
  }
  getOrgEmailTemplates(){
    this.isLoading=true
    this.emailnotificationService.getOrgEmailTemplates(this.orgId).subscribe(
      (response:any)=>{
        if(!response.error){
          this.emailTemplates = new MatTableDataSource(response);
          this.emailTemplates.paginator=this.paginator
          this.emailTemplates.sort = this.sort;
          this.noData = this.emailTemplates.connect().pipe(map(data => data.length === 0));
          this.emailTemplates.sortingDataAccessor = (item, property) => {
            if (property === 'status') {
              return item.isActive;
            }
            else if(property === 'applicationName'){
              return item.appDetail.application_name
            }
            else {
              return item[property];
            }
          };
        }
        this.isLoading=false
        },
        error => {
          this.isLoading=false
          console.log(
            'Error in getting template'
          )
        });
  }
  toggleClass() {
    if (this.dropdown.nativeElement.className.includes('open'))
      this.dropdown.nativeElement.className = 'dropdown';
    else
      this.dropdown.nativeElement.className = 'dropdown open';

  }
}

